$(function () {
    // @ vars ------------------------------------------
    let timer_check_ajax

    // @ funcs ------------------------------------------
    const checkAllAjaxComplete = () => {
        if (jQuery.active === 0) {
            clearInterval(timer_check_ajax)
            let $autoscroll = $('#autoscroll')
            if ($autoscroll.length > 0) {
                $('html, body').animate(
                    {
                        scrollTop: $autoscroll.offset().top - 40,
                    },
                    'slow'
                )
            }
        }
    }

    // @ inits ------------------------------------------
    timer_check_ajax = setInterval(checkAllAjaxComplete, 1000) // Check every second
})
